// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"85":"component---src-pages-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"85":"9818cfa54276ffbd18c2","883":"5f0992fbb3bef27ba262"}[chunkId] + ".js";
};